export const RERENDER_TOP_BROKERS_COMPONENT_BUS_NAME =
  'RERENDER_TOP_BROKERS_COMPONENT_BUS_NAME'
